import Vue from 'vue'

Vue.prototype.$score = (A: any, B: any, C: any, D: any, E: any, F: any, PBA: any) => {
  A = A || 0;
  if (typeof A === 'string')
    A = parseFloat(A);
  B = B || 0;
  if (typeof B === 'string')
    B = parseFloat(B);
  C = C || 0;
  if (typeof C === 'string')
    C = parseFloat(C);
  D = D || 0;
  if (typeof D === 'string')
    D = parseFloat(D);
  E = E || 0;
  if (typeof E === 'string')
    E = parseFloat(E);
  F = F || 0;
  if (typeof F === 'string')
    F = parseFloat(F);
  PBA = PBA || 0;
  if (typeof PBA === 'string')
    PBA = parseFloat(PBA);

  var score = 0;

  switch (PBA) {
    case 0:
      {
        score = 5 * (A + B) + (5 / 2) * (C + D + E + F);
        break;
      }
    case 1:
      {
        score = 5 * A + (5 + (6 / 10)) * B + (5 / 2) * (C + D) + ((5 / 2) - (3 / 10)) * (E + F);
        break;
      }
    case 2:
      {
        score = 5 * A + (5 + 1) * B + (5 / 2) * (C + D) + ((5 / 2) - (1 / 2)) * (E + F);
        break;
      }
    case 3:
      {
        score = 5 * A + (5 + (14 / 10)) * B + (5 / 2) * (C + D) + ((5 / 2) - (7 / 10)) * (E + F);
        break;
      }
  }

  return (Math.round(score * 2) / 2).toFixed(1);
}

Vue.prototype.$score_enforceability = (A: any, B: any, C: any, D: any) => {
  A = A || 0;
  if (typeof A === 'string')
    A = parseFloat(A);
  B = B || 0;
  if (typeof B === 'string')
    B = parseFloat(B);
  C = C || 0;
  if (typeof C === 'string')
    C = parseFloat(C);
  D = D || 0;
  if (typeof D === 'string')
    D = parseFloat(D);

  var score = 0;

  score = 5 * A + 8 * B + 3.5 * (C + D);

  return score;
}
